import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSoundBars = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	fill: "currentColor",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("style", { children: "\n    .spinner_7uc5 {\n      animation: spinner_3l8F 1.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) infinite;\n      animation-delay: -0.9s;\n    }\n    .spinner_RibN {\n      animation-delay: -0.7s;\n    }\n    .spinner_ZAxd {\n      animation-delay: -0.5s;\n    }\n    @keyframes spinner_3l8F {\n      0% {\n        opacity: 0.8;\n      }\n      66.66% {\n        opacity: 0.9;\n      }\n      0%, 66.66% {\n        animation-timing-function: cubic-bezier(0.14, 0.73, 0.34, 1);\n        y: 8px; /* Adjusted from 6px to 8px */\n        height: 8px; /* Adjusted from 12px to 8px */\n      }\n      33.33% {\n        animation-timing-function: cubic-bezier(0.65, 0.26, 0.82, 0.45);\n        y: 4px; /* Adjusted from 1px to 4px */\n        height: 16px; /* Adjusted from 22px to 16px */\n        opacity: 0.9;\n      }\n      100% {\n        opacity: 1;\n      }\n    }\n  " }),
		/* @__PURE__ */ _jsx("rect", {
			className: "spinner_7uc5 spinner_RibN",
			x: 6.5,
			y: 8,
			width: 2.8,
			height: 8,
			rx: 1.4,
			ry: 1.4
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "spinner_7uc5",
			x: 10.1,
			y: 8,
			width: 2.8,
			height: 8,
			rx: 1.4,
			ry: 1.4
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "spinner_7uc5 spinner_ZAxd",
			x: 13.7,
			y: 8,
			width: 2.8,
			height: 8,
			rx: 1.4,
			ry: 1.4
		})
	]
});
const ForwardRef = forwardRef(SvgSoundBars);
export { ForwardRef as ReactComponent };
